enum HorizontalDirectionEnum {
  Left = 'LEFT',
  Right = 'RIGHT',
}

export default HorizontalDirectionEnum;
